import { useQuery, QueryFunction } from 'react-query';
import {
    getAllSubContractors,
    GetAllSubContractorsQueries,
    GetMonthlySubContractorParams,
    getMonthlySubContractors,
    MonthlySubContractor,
    SubContractor,
} from '../../services/apiSLTP/materials/subContractors';

type UseSubContractorsQueryOptions = {
    queries?: GetAllSubContractorsQueries;
};

const getSubContractors: QueryFunction<SubContractor[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseSubContractorsQueryOptions];
    const { queries } = options;

    const response = await getAllSubContractors(queries);
    return response.data;
};

export const useSubContractorsQuery = (options: UseSubContractorsQueryOptions) => {
    return useQuery(['subContractors', options], getSubContractors);
};

type UseMonthlySubContractorsQueryOptions = {
    params: GetMonthlySubContractorParams;
};

const getMonthlySubContractorsQuery: QueryFunction<MonthlySubContractor[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMonthlySubContractorsQueryOptions];
    const { params } = options;

    const response = await getMonthlySubContractors(params);
    return response.data;
};

export const useMonthlySubContractorsQuery = (options: UseMonthlySubContractorsQueryOptions) => {
    return useQuery(['monthly sub contractors', options], getMonthlySubContractorsQuery);
};
